import { atom } from 'recoil';
import Cookies from 'universal-cookie';
import { useSetRecoilState } from 'recoil';

const cookies = new Cookies();

export const errorMessage = atom({
  key: 'errorMessage',
  default: ''
});

export const isTokenAvailable = atom({
  key: 'isTokenAvailable',
  default: false
});

export const currentRole = atom({
  key: 'currentRole',
  default: ''
});

export const useSetCurrentRole = () => {
  const setCurrentRole = useSetRecoilState(currentRole);
  return (role: any) => {
    window.sessionStorage.setItem('currentRole', role);
    setCurrentRole(role);
  };
};
